<template>
  <div class="timeline-item">
    <div class="timeline-badge">
      <div :style="markerStyle" :class="markerClasses">
        <token-small :hasShadow="true" :type="tokenType"></token-small>
      </div>
    </div>
    <div class="timeline-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>

import TokenSmall from 'top20common/components/icons/tokens/TokenSmall';
import TimelineItem from 'top20common/components/timeline/TimelineItem';

export default {
  extends: TimelineItem,
  props: {
    tokenType: String
  },
  data() {
    return {
      markerHeightPx: 8
    };
  },
  computed: {
    markerClasses() {
      return 'marker';
    },
    markerMarginLeft() {
      return '-4px';
    },
    marginTopAfter() {
      return '-2px';
    },
    marginLeftAfter() {
      return '7px';
    },
    markerHeightAfter() {
      const height = this.$mq.phone ? this.heightAfter + this.markerHeightPx : this.heightAfter;
      return `${height}px`;
    }
  },
  components: {TokenSmall}
};
</script>
<style lang="scss" scoped>
@import 'top20common/components/timeline/timeline-item.scss';
</style>
